// import { storagePrefix } from '@/service/configLocalStorage';
interface ResolvePageSizeParams {
  sizes: Record<number, number>;
  _default: number;
}


export const resolvePageSize = (viewName = 'viewName', { _default, sizes }: ResolvePageSizeParams) => {
  // const manual = window.localStorage.getItem(`${storagePrefix}${viewName}`);
  const manual = window.localStorage.getItem(`${viewName}`);
  if (manual && manual !== 'null') {
    return parseInt(manual, 10);
  }

  const screenHeight = window.screen.height;

  if (sizes[screenHeight]) return sizes[screenHeight];

  if (screenHeight >= 1080 && screenHeight <= 1200) {
    return sizes[1080] ?? _default;
  }

  if (screenHeight > 1200 && screenHeight < 1440) {
    return sizes[1440] ?? _default;
  }

  return _default;
};

export const pageSizeMixin = {
  updated() {
    setTimeout(() => {
      //@ts-expect-error wip @/composables/usePageSize.ts
      const { pageLimitProp = 'limit', viewName = 'viewName' } = this;
      //@ts-expect-error wip @/composables/usePageSize.ts
      this.$ls.set(viewName, this[pageLimitProp]);
    }, 1000);
  },
};
